//* 부고 추가 일정(영결식·입관예배 등) 규칙 — 백엔드 fevent.extra-schedules.ts 와 동일하게 유지
//* docs/fevent-extra-schedules-spec.md
import { FeventDate } from '@shared/types';

import { FeventExtraSchedule, FeventExtraScheduleAfter } from './fevent.interface';

export const EXTRA_SCHEDULE_MAX_COUNT = 5;
export const EXTRA_SCHEDULE_LABEL_MAX_LENGTH = 20;

export const EXTRA_SCHEDULE_ANCHORS: FeventExtraScheduleAfter[] = [
  'enterance',
  'coffinIn',
  'coffinOut',
];

export const EXTRA_SCHEDULE_ANCHOR_LABEL: Record<FeventExtraScheduleAfter, string> = {
  enterance: '입실',
  coffinIn: '입관',
  coffinOut: '발인',
};

//* 고인정보 폼의 행 모양 — 날짜/시각 피커가 {date, timeDefined} 를 통째로 setValue 하므로 fDate 로 감쌈
export type FeventExtraScheduleFormRow = {
  key: string; // 행 식별(피커의 recoil time atom 키와 묶임) — 삭제 시 뒤 행의 시각이 밀리지 않게
  label: string;
  after: FeventExtraScheduleAfter;
  fDate: FeventDate;
};

let rowSeq = 0;
export const newExtraScheduleRowKey = () =>
  `extra-${Date.now().toString(36)}-${rowSeq++}`;

export const toExtraScheduleFormRows = (
  list?: FeventExtraSchedule[] | null,
): FeventExtraScheduleFormRow[] =>
  (list ?? []).map((item) => ({
    key: item._id ?? newExtraScheduleRowKey(),
    label: item.label,
    after: item.after,
    fDate: { date: item.date ?? null, timeDefined: !!item.timeDefined },
  }));

//* 제출 payload — 생성·수정 모두 항상 배열로 보낸다(빈 [] 포함, 통째 PATCH 함정)
export const toExtraSchedulesPayload = (
  rows?: FeventExtraScheduleFormRow[] | null,
): FeventExtraSchedule[] =>
  (rows ?? [])
    .filter((row) => row.fDate?.date)
    .map((row) => ({
      label: row.label.trim(),
      date: row.fDate.date as Date,
      timeDefined: !!row.fDate.timeDefined,
      after: row.after,
    }));

//* 제출 전 클라이언트 검증 — 통과면 null, 아니면 사용자 안내 문구
export const validateExtraScheduleRows = (
  rows?: FeventExtraScheduleFormRow[] | null,
): string | null => {
  const list = rows ?? [];
  if (list.length > EXTRA_SCHEDULE_MAX_COUNT) {
    return `추가 일정은 최대 ${EXTRA_SCHEDULE_MAX_COUNT}개까지 입력할 수 있습니다`;
  }
  for (const row of list) {
    const label = row.label?.trim() ?? '';
    if (!label) return '추가 일정의 이름을 입력해주세요';
    if (label.length > EXTRA_SCHEDULE_LABEL_MAX_LENGTH) {
      return `추가 일정 이름은 ${EXTRA_SCHEDULE_LABEL_MAX_LENGTH}자 이내로 입력해주세요`;
    }
    if (!row.fDate?.date) return `'${label}' 일정의 날짜를 선택해주세요`;
    if (!EXTRA_SCHEDULE_ANCHORS.includes(row.after)) {
      return `'${label}' 일정의 표시 위치를 선택해주세요`;
    }
  }
  return null;
};

//* 부고장 노출 — 앵커별 묶음(배열 순서 유지). 앵커 고정 행이 비어 있어도 그 자리에 그린다
export const groupExtraSchedulesByAnchor = (
  list?: FeventExtraSchedule[] | null,
): Record<FeventExtraScheduleAfter, FeventExtraSchedule[]> => {
  const grouped: Record<FeventExtraScheduleAfter, FeventExtraSchedule[]> = {
    enterance: [],
    coffinIn: [],
    coffinOut: [],
  };
  (list ?? []).forEach((item) => {
    if (!item || !item.date) return;
    const bucket = grouped[item.after];
    if (bucket) bucket.push(item);
  });
  return grouped;
};
